import { parseLottoQr, type TicketImportResult } from "./lotto-ticket-engine";

interface DetectedBarcode { readonly rawValue?: string }
interface NativeBarcodeDetector { detect(source: ImageBitmap): Promise<readonly DetectedBarcode[]> }
interface NativeBarcodeDetectorConstructor { new (options: { formats: readonly string[] }): NativeBarcodeDetector }

/**
 * Reads an image on the device with the browser's native QR detector.  The
 * image and raw QR value are passed directly to the local parser and are never
 * uploaded, logged, or persisted.
 */
export async function scanLottoTicketImage(file: File): Promise<TicketImportResult> {
  if (!file.type.startsWith("image/")) throw new Error("이미지 파일만 읽을 수 있습니다.");
  const Detector = (globalThis as typeof globalThis & { BarcodeDetector?: NativeBarcodeDetectorConstructor }).BarcodeDetector;
  if (!Detector || !globalThis.createImageBitmap) throw new Error("이 브라우저는 카메라 QR 읽기를 지원하지 않습니다. QR 내용을 붙여 넣어 주세요.");
  const bitmap = await globalThis.createImageBitmap(file);
  try {
    const barcode = (await new Detector({ formats: ["qr_code"] }).detect(bitmap)).find((item) => item.rawValue?.trim());
    if (!barcode?.rawValue) throw new Error("이미지에서 복권 QR을 찾지 못했어요.");
    return parseLottoQr(barcode.rawValue);
  } finally { bitmap.close(); }
}
